import React from 'react'
import { spring } from 'react-motion'
import EasingMotion from './easing-motion'
import RangeFence from './easing-box/range-fence'
import MedianLine from './easing-box/median-line'
import QuartileBox from './easing-box/quartile-box'
import CurrentDot from './easing-box/current-dot'
import Cross from './cross'

import { CHART_DEBUG, SPRING } from '../constants'

class EasingBox extends React.PureComponent {
  static defaultProps = {
    opacity: 1
  }

  renderClipping(style) {
    const { min, max, lower, upper, width, x } = style

    let top = max == null ? upper * 0.9 : max
    let bottom = min == null ? lower * 1.1 : min

    // "or" to zero in case min and max aren't defined
    let y1 = Math.min(top, bottom)
    let y2 = Math.max(top, bottom)

    return (
      <rect
        x={x}
        y={y1}
        height={y2 - y1}
        width={width}
        stroke={CHART_DEBUG ? 'magenta' : 'none'}
        strokeDasharray="2 2"
        fill="transparent"
      />
    )
  }

  getBoxWidth(width) {
    return Math.min(25, width)
  }

  getBoxX(x, width) {
    const boxWidth = this.getBoxWidth(width)
    const offset = Math.max(0, width - boxWidth) * 0.5

    return x + offset
  }

  renderBox(style) {
    let { current, lower, upper, median, min, max, fairValue, x, width } = style

    let boxX = this.getBoxX(x, width)
    let boxWidth = this.getBoxWidth(width)
    let crossSize = Math.min(4, boxWidth * 0.25)
    let centerX = boxX + boxWidth * 0.5

    return (
      <g className="easing-box">
        {this.renderClipping(style)}

        <RangeFence x={boxX} y1={max} y2={min} width={boxWidth} />

        <QuartileBox x={boxX} y1={upper} y2={lower} width={boxWidth} />
        <MedianLine x={boxX} y={median} width={boxWidth} />
        <CurrentDot x={boxX} y={current} width={boxWidth} />

        {fairValue != null && (
          <Cross
            x={centerX}
            y={fairValue}
            r={crossSize}
            stroke="black"
            strokeWidth={crossSize / 2}
          />
        )}
      </g>
    )
  }

  getStyle() {
    const {
      x,
      current,
      lower,
      min,
      max,
      fairValue,
      upper,
      median,
      width
    } = this.props

    let style = {
      x: spring(x, SPRING),
      current: spring(current, SPRING),
      upper: spring(upper, SPRING),
      median: spring(median, SPRING),
      lower: spring(lower, SPRING),
      width: spring(width, SPRING)
    }

    // The following properties are optional:

    if (fairValue != null) {
      style.fairValue = spring(fairValue, SPRING)
    }
    if (min != null) {
      style.min = spring(min, SPRING)
    }
    if (max != null) {
      style.max = spring(max, SPRING)
    }

    return style
  }

  render() {
    const { opacity, label, fill, stroke } = this.props

    return (
      <g opacity={opacity} fill={fill} stroke={stroke}>
        <title>{label}</title>

        <EasingMotion style={this.getStyle()} static={this.props}>
          {style => this.renderBox(style)}
        </EasingMotion>
      </g>
    )
  }
}

export default EasingBox



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-box.js